import ld from 'lodash';
import Vue from 'vue';
import moment from 'moment';

import {
  LOGIN,
  LOGOUT,
  SETTINGS,
  TOGGLE_LOCALE,
  SAVE_SETTINGS,
  SET_COLOR,
  LOAD_QR_TELEGRAM,
  ACTIVATE_CHANGE_PASSWORD,
  CHANGE_PASSWORD,
  SET_SHOWCODES,
  SET_MODALITA_ESTESA,
  CLEAR_USER_PREF,
  CALENDAR_SET,
  SNACKBAR,
  SET_SHOWCONCORDATI,
} from '@/store/types';

import http from '@/http';

const colors = [
  'red',
  'pink',
  'purple',
  'deep-purple',
  'indigo',
  'blue',
  'light-blue',
  'cyan',
  'teal',
  'green',
  'lime',
  'yellow',
  'orange',
  'deep-orange',
  'brown',
  'blue-grey',
];

const actions = {
  [LOGIN]: async ({ commit, dispatch }, { username, password }) => {
    let resp;
    try {
      resp = await http.post('auth/login', null, {
        headers: {
          Authorization: `Basic ${btoa(`${username}:${password}`)}`,
        },
      });
    } catch (err) {
      resp = err;
    }
    if (resp.status === 200) {
      commit(LOGIN, resp.data);
      dispatch(SETTINGS);
      return true;
    }
    if (resp.status === 204) {
      return false;
    }
    const msg = resp.response.data;
    return msg;
  },
  [CHANGE_PASSWORD]: async ({ commit, dispatch }, { username, password, newPassword }) => {
    let resp;
    try {
      resp = await http.post('auth/change-password', { newPassword }, {
        headers: {
          Authorization: `Basic ${btoa(`${username}:${password}`)}`,
        },
      });
    } catch (err) {
      resp = err;
    }
    if (resp.status === 200) {
      commit(LOGIN, resp.data);
      dispatch(SETTINGS);
      return true;
    }
    if (resp.status === 204) {
      return false;
    }
    const msg = resp.response.data;
    return msg;
  },
  [SETTINGS]: async ({ commit, state, getters }, fromLogin = true) => {
    if (!state.token) {
      commit(LOGOUT);
      return;
    }
    let resp;
    try {
      resp = await http.get('auth/settings');
    } catch (err) {
      resp = err;
    }
    if (resp.status === 200) {
      commit(SETTINGS, resp.data);
      if (getters.calendar.type === 'P') {
        let from;
        let to;
        switch (getters.calendar.period) {
          case 'O':
            from = moment().format('YYYY-MM-DD');
            to = moment().format('YYYY-MM-DD');
            break;
          case 'I':
            from = moment().subtract(1, 'day').format('YYYY-MM-DD');
            to = moment().subtract(1, 'day').format('YYYY-MM-DD');
            break;
          case 'U7G':
            from = moment().subtract(7, 'days').format('YYYY-MM-DD');
            to = moment().format('YYYY-MM-DD');
            break;
          case 'MC':
            from = moment().startOf('month').format('YYYY-MM-DD');
            to = moment().format('YYYY-MM-DD');
            break;
          case 'AC':
            from = moment().startOf('year').format('YYYY-MM-DD');
            to = moment().format('YYYY-MM-DD');
            break;
          default:
            break;
        }
        commit(CALENDAR_SET, {
          ...getters.calendar,
          from,
          to,
        });
      }
      if (!fromLogin) commit(SNACKBAR, { type: 'info', msg: 'Bentornato!' });
    } else {
      commit(LOGOUT);
    }
  },
  [SAVE_SETTINGS]: async ({ commit }, settings) => {
    let resp;
    try {
      resp = await http.post('auth/settings', settings);
    } catch (err) {
      resp = err;
    }
    if (resp.status === 200) {
      commit(SAVE_SETTINGS, resp.data);
      return true;
    }
    return false;
  },
  [LOAD_QR_TELEGRAM]: async () => {
    let resp;
    try {
      resp = await http.get('auth/qr-telegram');
    } catch (err) {
      resp = err;
    }
    if (resp.status === 200) {
      return resp.data;
    }
    return false;
  },
  [ACTIVATE_CHANGE_PASSWORD]: async ({ commit }) => {
    let resp;
    try {
      resp = await http.get('auth/activate-change-password');
    } catch (err) {
      resp = err;
    }
    if (resp.status === 200) {
      commit(LOGOUT);
      return resp.data;
    }
    return false;
  },
  [SET_MODALITA_ESTESA]: async ({ commit }, password) => {
    let resp;
    try {
      resp = await http.post('auth/login-ext', { password });
    } catch (err) {
      resp = err;
    }
    if (resp.status === 200 && resp.data === true) {
      commit(SET_MODALITA_ESTESA, 'OSV');
      return resp.data;
    }
    commit(SET_MODALITA_ESTESA, 'FOSV');
    return false;
  },
  [LOGOUT]: async ({ commit }) => {
    commit(SET_MODALITA_ESTESA, 'NRM');
    commit(LOGOUT);
  },
};

const mutations = {
  [CLEAR_USER_PREF]: () => {}, // Al momento non utilizzato
  [LOGIN]: (state, token) => {
    http.defaults.headers.Authorization = `Bearer ${token}`;
    Vue.set(state, 'token', token);
  },
  [LOGOUT]: (state) => {
    delete http.defaults.headers.Authorization;
    ld.merge(state, {
      token: null,
      checkedLoginStatus: true,
      settings: null,
    });
  },
  [SETTINGS]: (state, settings) => {
    const { locali, guid } = settings;
    const localiList = locali.map(({ id }) => id);

    if (!ld.has(state.userPreferences, guid)) {
      const avColors = ld.sampleSize(colors, localiList.length);
      Vue.set(state.userPreferences, guid, {});
      Vue.set(state.userPreferences[guid], 'localiAttivi', [...localiList]);
      Vue.set(state.userPreferences[guid], 'coloriLocali', ld.reduce(localiList, (c, n, i) => ({ ...c, [n]: avColors[i] }), {}));
      Vue.set(state.userPreferences[guid], 'mostraCodiciArticolo', false);
      Vue.set(state.userPreferences[guid], 'mostraConcordati', true);
      Vue.set(state.userPreferences[guid], 'modalita', 'NRM');
      Vue.set(state.userPreferences[guid], 'calendar', {
        type: 'P', // DATA || PERIODO
        period: 'U7G',
        from: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
      });
    }

    const avColors = colors.filter(c => !Object
      .values(state.userPreferences[guid].coloriLocali).includes(c));
    ld.forEach(localiList, (locale, i) => {
      if (!(locale in state.userPreferences[guid].coloriLocali)) {
        Vue.set(state.userPreferences[guid].coloriLocali, locale, avColors[i]);
      }
    });

    ld.merge(state, {
      settings,
      checkedLoginStatus: true,
    });
  },
  [TOGGLE_LOCALE]: (state, locale) => {
    const guid = ld.get(state, 'settings.guid', null);
    const localiAttivi = ld.get(state.userPreferences[guid], 'localiAttivi', []);
    const index = localiAttivi.findIndex(l => l === locale);
    if (index === -1) localiAttivi.push(locale);
    else if (localiAttivi.length > 1) state.userPreferences[guid].localiAttivi.splice(index, 1);
  },
  [SET_SHOWCODES]: (state, value) => {
    const guid = ld.get(state, 'settings.guid', null);
    Vue.set(state.userPreferences[guid], 'mostraCodiciArticolo', value || false);
  },
  [SET_SHOWCONCORDATI]: (state, value) => {
    const guid = ld.get(state, 'settings.guid', null);
    Vue.set(state.userPreferences[guid], 'mostraConcordati', value || false);
  },
  [SET_MODALITA_ESTESA]: (state, value) => {
    const guid = ld.get(state, 'settings.guid', null);
    Vue.set(state.userPreferences[guid], 'modalita', value || false);
  },
  [SAVE_SETTINGS]: (state, settings) => {
    Vue.set(state.settings, 'settings', settings);
  },
  [SET_COLOR]: (state, [id, color]) => {
    const guid = ld.get(state, 'settings.guid', null);
    Vue.set(state.userPreferences[guid].coloriLocali, id, color);
  },
  [CALENDAR_SET]: (state, newCalendar) => {
    const guid = ld.get(state, 'settings.guid', null);
    Vue.set(state.userPreferences[guid], 'calendar', { ...newCalendar });
  },
  [SNACKBAR]: (state, { type, msg }) => {
    Vue.set(state, 'snackbar', { type, msg });
  },
};

const getters = {
  guid(state) {
    return ld.get(state, 'settings.guid', null);
  },
  userPreferences(state, gettersList) {
    return ld.get(state.userPreferences, gettersList.guid, {});
  },
  loggedIn(state) {
    return state.checkedLoginStatus === true && !!state.token;
  },
  settingsLoaded(state) {
    return !!state.settings;
  },
  settings(state) {
    return state.settings;
  },
  localiAttivi(state, gettersList) {
    return ld.get(gettersList.userPreferences, 'localiAttivi', []);
  },
  descrLocale(state) {
    return (id) => {
      if (state.settings) {
        return (state.settings.locali.find(l => l.id === id) || { nome: '' }).nome;
      }
      return '';
    };
  },
  yearmin(state) {
    return ld.get(state, 'settings.calendario.min', moment().year());
  },
  yearmax(state) {
    return ld.get(state, 'settings.calendario.max', moment().year());
  },
  multiMode(state, gettersList) {
    return gettersList.localiAttivi.length > 1;
  },
  colors() {
    return colors;
  },
  coloreLocale(state, gettersList) {
    return id => ld
      .get(gettersList.userPreferences, `coloriLocali[${id}]`);
  },
  moduli(state) {
    return ld.get(state, 'settings.moduli', []);
  },
  mostraCodiciArticolo(state, gettersList) {
    return ld.get(gettersList.userPreferences, 'mostraCodiciArticolo', false);
  },
  mostraConcordati(state, gettersList) {
    return ld.get(gettersList.userPreferences, 'mostraConcordati', true);
  },
  modalita(state, gettersList) {
    return ld.get(gettersList.userPreferences, 'modalita', 'NRM');
  },
  modalitaEstesa(state, gettersList) {
    return gettersList.modalita === 'OSV';
  },
  locali(state, gettersList) {
    return ld.get(state, 'settings.locali', [])
      .filter(({ id }) => gettersList.localiAttivi.indexOf(id) !== -1);
  },
  calendar(state, gettersList) {
    return ld.get(gettersList.userPreferences, 'calendar', {
      type: 'P', // DATA || PERIODO
      period: 'U7G',
      from: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
    });
  },
};

const state = {
  checkedLoginStatus: false,
  settings: null,
  token: null,
  userPreferences: {},
  snackbar: null,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
